import React from 'react';
import LanguageDropdown from './LanguageDropdown';

const LanguageSelector: React.FC = () => <LanguageDropdown variant="header" />;

export default LanguageSelector;
